import React from 'react';
import { Form, InputGroup, FormControl, Button, Spinner, Alert } from 'react-bootstrap';
import { Form as FinalForm, Field } from 'react-final-form';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Cart4, ExclamationOctagon, CheckCircle } from '@styled-icons/bootstrap';

function CompCart(props) {
  const onSubmit = async values => {
    if ((Object.keys(props.cart.promotionalCode)).length !== 0) {
      props.clearCart();
      return;
    }
    if (!values.promotionalCode) {
      return { promotionalCode: 'Preencha o campo.' }
    }
    const resp = await props.addPromotionalCode(values.promotionalCode)
    if (resp.error !== '') {
      return { promotionalCode: resp.error };
    }
  }
  return (
    <div className="clearfix my-2 d-inline">
      <div className="col-md-6 p-0 float-left">
        <FinalForm
          onSubmit={onSubmit}
          /* validate={values => {
            const errors = {}
            if (!values.codigoPromocional) {
              errors.codigoPromocional = 'Preencha o campo.'
            }
            return errors
          }} */
          render={({
            submitError,
            handleSubmit,
            form,
            submitting,
            pristine,
            values }) => (
              <Form onSubmit={handleSubmit}>
                <Field name="promotionalCode">
                  {({ input, meta }) => (
                    <>
                      <InputGroup>
                        <FormControl
                          {...input}
                          placeholder="Código Promocional"
                          aria-label="Código Promocional"
                          value={(() => {
                            if ((Object.keys(props.cart.promotionalCode)).length !== 0) {
                              return props.cart.promotionalCode.codigo;
                            }
                            return input.value;
                          })()}
                          disabled={(() => {
                            if ((Object.keys(props.cart.promotionalCode)).length !== 0) {
                              return true;
                            }
                            return false;
                          })()}
                        />
                        <InputGroup.Prepend>
                          {((Object.keys(props.cart.promotionalCode)).length === 0) ?
                            <Button style={{ width: "5.5rem" }} type="submit" disabled={submitting}>
                              {props.pendingTasks ?
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /> : 'Aplicar'
                              }
                            </Button>
                            :
                            <Button style={{ width: "5.5rem" }} onClick={form.reset} variant="danger" type="submit" disabled={submitting}>
                              Limpar
                          </Button>
                          }
                        </InputGroup.Prepend>
                      </InputGroup>
                      {(() => {
                        if ((Object.keys(props.cart.promotionalCode)).length === 0) {
                          if ((meta.error || meta.submitError) && meta.touched) {
                            return (<Alert className="px-2 py-0 mb-0" variant="danger"><ExclamationOctagon size={20} className="mr-1" />{meta.error || meta.submitError}</Alert>);
                          }
                        } else {
                          return (
                            <Alert className="px-2 py-0 mb-0" variant="success">
                              <CheckCircle size={20} className="mr-1" />
                              Código {props.cart.promotionalCode.codigo} aplicado com sucesso!
                              <br />{`Será dado o desconto de `}{(() => {
                                let text;
                                if ((props.cart.promotionalCode.valor > 0) &&
                                  (props.cart.promotionalCode.consideracumulativo === "N")) {
                                  text = " no fechamento do pedido.";
                                } else {
                                  text = " para cada produto adquirido.";
                                }
                                return (props.cart.promotionalCode.valor > 0 ?
                                  (props.cart.promotionalCode.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) :
                                  ((+props.cart.promotionalCode.percentual).toFixed()) + "%") + text;
                              })()}
                            </Alert>
                          );
                        }
                      })()}
                    </>
                  )}
                </Field>
              </Form>
            )}
        />
      </div>
      <div style={{ top: "56px", zIndex: "999" }} className="carrinho col-md-6 position-sticky bg-white d-block p-0 float-left">
        <InputGroup>
          <span style={{
            backgroundColor: "rgba(0, 0, 0, 0.03)",
            border: "1px solid rgba(0, 0, 0, 0.125)",
            lineHeight: "2rem",
            borderRadius: "5px 0px 0px 5px"
          }} className="cifrao px-4">
            <Cart4 size={20} className="mr-1" />
          </span>
          <span style={{
            backgroundColor: "rgba(0, 0, 0, 0.03)",
            border: "1px solid rgba(0, 0, 0, 0.125)",
            lineHeight: "2.2rem"
          }}
            className="valor text-center flex-fill px-3">
            {(() => {
              let value = props.cart.products.reduce(
                (total, prod) => +(prod.qt) *
                  +(props.store.products.find((carrItem) => {
                    return carrItem.idsubitems === prod.idsubitems;
                  }).productValueSell) + total, 0);
              let discount = 0;
              if (Object.keys(props.cart.promotionalCode).length !== 0) {
                if (props.cart.promotionalCode.consideracumulativo === "N"
                  && props.cart.promotionalCode.valor !== 0) {
                  discount = value - props.cart.promotionalCode.valor;
                  if (discount > 0) {
                    return (
                      <>
                        <s>{value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</s>
                        {" " + discount.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                      </>);
                  }
                }
              }
              return value = value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            })()
            }
          </span>
          <InputGroup.Prepend>
              <Button 
              disabled={(() => {
                if (props.cart.products.length !== 0) {
                  return false;
                }
                return true;
              })()}
              onClick={props.next} 
              style={{ width: "5.5rem" }} 
              variant="success">Próximo</Button>
          </InputGroup.Prepend>
        </InputGroup>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    pendingTasks: state.pendingTasks
  };
}

export default connect(mapStateToProps, null)(CompCart);
